import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Button, Icon } from 'antd';
import { Permission } from 'components/page/index';
import PERMISSIONS from 'config/app-permission.config';
import TemplatesTable from './TemplatesTable';

const defaultProps = {};
const propTypes = {
  isSharedByVisible: PropTypes.bool.isRequired,
  isCurrentUser: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.bool
  ]).isRequired,
  setPermissionSettingVisible: PropTypes.func.isRequired,
  fetchNewTemplateData: PropTypes.func.isRequired,
};

const Templates = ({
  isSharedByVisible,
  isCurrentUser,
  setPermissionSettingVisible,
  fetchNewTemplateData,
}) => (
  <Fragment>
    {!isSharedByVisible && isCurrentUser() &&
      <Permission permission={PERMISSIONS.SETUP_EMAILCOMMUNICATIONS_EMAILTEMPLATES_ADD}>
        <div className="text-right mt-md mb-md ml-lg mr-lg">
          <Link to="/setup/email/templates-creation">
            <Button
              className="btn-ellipse email-theme-btn"
              size="small"
              onClick={() => {
                fetchNewTemplateData(() => {
                    setPermissionSettingVisible(false);
                });
              }}
            >
              <Icon type="plus" />
              <FormattedMessage id="page.emailTemplates.addTemplate" />
            </Button>
          </Link>
        </div>
      </Permission>
    }
    <TemplatesTable
      isSharedByVisible={isSharedByVisible}
      isCurrentUser={isCurrentUser}
    />
  </Fragment>
);

Templates.defaultProps = defaultProps;
Templates.propTypes = propTypes;

export default Templates;



// WEBPACK FOOTER //
// ./src/views/email/emailTemplates/component/templateDetailComponent/templates.js